<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card-text>
          <v-row class="mb-2" justify="end">
            <v-col cols="12" sm="8" md="6" lg="4">
              <v-text-field
                class="ui-form-field mt-2"
                label="Buscar"
                v-model="searchEquipo"
                append-icon="mdi-magnify"
                rounded
                filled
                dense
                hide-details
                color="secondary"
                background-color="transparent"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-data-table :headers="headers" :items="equipos" class="transparent ui-module-table" :search="searchEquipo" :loading="loading">
            <template v-slot:[`item.opciones`]="{ item }">
              <v-btn
                icon
                class="mr-1 ui-module-icon-action"
                color="secondary"
                :loading="loadingEditarEquipo === item.idEquipamiento"
                @click="openUpdateEquipoDialog(item)"
                ><v-icon>mdi-pencil</v-icon></v-btn
              >
              <v-btn icon class="ui-module-icon-action" color="secondary" @click="openUpdateEstatusEquipoDialog(item)"
                ><v-icon>mdi-update</v-icon></v-btn
              >
            </template>
          </v-data-table>
        </v-card-text>
      </v-col>
    </v-row>
    <update-equipo-dialog-component
      :active="updateEquipoDialog"
      @close="updateEquipoDialog = false"
      :equipo="selectedEquipo"
    ></update-equipo-dialog-component>
    <estatus-equipo-dialog-component
      :active="updateEstatusEquipoDialog"
      @close="updateEstatusEquipoDialog = false"
      :equipo="selectedEquipo"
    ></estatus-equipo-dialog-component>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import EstatusEquipoDialogComponent from '../../components/equipamiento/EstatusEquipoDialogComponent.vue'
import UpdateEquipoDialogComponent from '../../components/equipamiento/UpdateEquipoDialogComponent.vue'

export default {
  components: {
    UpdateEquipoDialogComponent,
    EstatusEquipoDialogComponent,
  },

  async created() {
    this.$store.commit('equipo/CLEAR_EQUIPO')
    this.loading = true
    await this.fetchEquipo()
    this.loading = false
  },

  data() {
    return {
      loading: false,

      headers: [
        { text: 'Categoría', value: 'CatItem.CatTipoItem.title' },
        { text: 'Item', value: 'CatItem.item' },
        { text: 'Número', value: 'numero' },
        { text: 'Fecha de fabricación', value: 'fechaFabricacion' },
        { text: 'Vigencia', value: 'aniosVigencia' },
        { text: 'Estatus', value: 'CatEstatus.title' },
        { text: 'Opciones', value: 'opciones' },
      ],

      updateEquipoDialog: false,
      updateEstatusEquipoDialog: false,

      selectedEquipo: null,
      loadingEditarEquipo: false,

      searchEquipo: '',
    }
  },

  computed: {
    ...mapGetters('equipo', {
      equipos: 'getEquipos',
    }),
  },

  methods: {
    ...mapActions('equipo', ['fetchEquipo']),

    async openUpdateEquipoDialog(equipo) {
      this.loadingEditarEquipo = equipo.idEquipamiento
      await this.$nextTick()
      this.loadingEditarEquipo = false
      this.selectedEquipo = equipo
      this.updateEquipoDialog = true
    },

    openUpdateEstatusEquipoDialog(equipo) {
      this.selectedEquipo = equipo
      this.updateEstatusEquipoDialog = true
    },
  },
}
</script>

<style scoped>
.equipo-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}

.text-h6 {
  color: #ffbe76 !important;
  font-weight: 700;
}

/* Input de búsqueda */
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(255, 159, 67, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(255, 159, 67, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label,
::v-deep .ui-form-field .mdi-magnify {
  color: rgba(255, 190, 118, 0.75) !important;
  font-weight: 500;
}

::v-deep .ui-form-field.v-input--is-focused .v-label {
  color: #ffbe76 !important;
  font-weight: 600;
}

::v-deep .v-btn.v-btn--icon {
  background: rgba(255, 159, 67, 0.1);
  border: 1px solid rgba(255, 159, 67, 0.2);
}

::v-deep .v-btn.v-btn--icon:hover {
  background: rgba(255, 159, 67, 0.2);
  border-color: #ff9f43;
}

::v-deep .v-icon {
  color: #ffbe76 !important;
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  color: #ff9f43 !important;
  transform: scale(1.2);
}

/* Data Footer */
::v-deep .v-data-footer {
  background: rgba(46, 36, 22, 0.4) !important;
  border-top: 1px solid rgba(255, 159, 67, 0.2) !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__select .v-select {
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__select .v-select__selection {
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer .v-icon {
  color: rgba(255, 159, 67, 0.6) !important;
}

::v-deep .v-data-footer .v-btn:hover .v-icon {
  color: #ff9f43 !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 159, 67, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 159, 67, 0.6);
}
</style>
